// extracted by mini-css-extract-plugin
module.exports = {"serial_input":"MyEquipmentSerialInput_serial_input__rTQnx"};